// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentEditor_container__YIMmQ","editor":"ContentEditor_editor__3BsiO","body":"ContentEditor_body__32ZYo"};